export default __webpack_public_path__ + "static/Moon-1b01a5147ee149028b44aa125bd4c3ce.svg";